import React from 'react';

import { ModalType } from '@/API/models';
import Modal from '@/components/Modal';
import CancelSubscriptionModal from '@/components/Modals/CancelSubscriptionModal';
import DowngradeModal from '@/components/Modals/DowngradeModal';
import UpgradeModal from '@/components/Modals/UpgradeModal';

const SubscriptionModals = ({
  type,
  isOpen,
  onClose,
  handleOpenModal,
  selectedPlanPriceId,
}: {
  type?: ModalType;
  isOpen: boolean;
  onClose: () => void;
  handleOpenModal: (type: ModalType) => void;
  selectedPlanPriceId: string;
}) => {
  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={onClose}
        shouldCloseOnOverlayClick={true}
        additionalStyles={{ maxWidth: '494px' }}
      >
        {type === 'downgrade' && (
          <DowngradeModal
            handleOpenModal={handleOpenModal}
            selectedPlanPriceId={selectedPlanPriceId}
          />
        )}
        {type === 'upgrade' && (
          <UpgradeModal
            handleOpenModal={handleOpenModal}
            selectedPlanPriceId={selectedPlanPriceId}
          />
        )}
        {type === 'cancel' && (
          <CancelSubscriptionModal handleOpenModal={handleOpenModal} />
        )}
      </Modal>
    </>
  );
};

export default SubscriptionModals;
